module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_8003.e7cf4f83.png";